import { MessageLevel } from "Static/@cortex/messages/enums/message_level_pb";
import { PayloadType } from "Static/@cortex/messages/enums/payload_type_pb";
import { TaskStatus } from "Static/@cortex/messages/enums/task_status_pb";
import {
  LEVEL_ERROR,
  LEVEL_INFO,
  LEVEL_SUCCESS,
  LEVEL_WARN,
} from "constant/messages";

// These must match cortex-api "messages/constants.py"
const CHAN_DEVICE_BULK_EDIT = "device::bulk-edit";
const CHAN_DEVICE_BULK_REGISTER = "device::bulk-register";
const CHAN_GENERIC_TASK = "task::generic";
const MESSAGE_LEVEL_MAP = {
  [MessageLevel.ERROR]: LEVEL_ERROR,
  [MessageLevel.WARNING]: LEVEL_WARN,
  [MessageLevel.INFO]: LEVEL_SUCCESS,
  [MessageLevel.DEBUG]: LEVEL_INFO,
};
const TASK_STATUS_MAP = {
  [TaskStatus.SUCCESS]: "completed",
  [TaskStatus.FAILURE]: "failed",
  [TaskStatus.STARTED]: "started",
  [TaskStatus.QUEUED]: "queued",
};
const VALID_MESSAGE_TYPES = [
  PayloadType.MESSAGE,
  PayloadType.PROGRESS,
  PayloadType.TASK_RESULT,
];

export {
  CHAN_DEVICE_BULK_EDIT,
  CHAN_DEVICE_BULK_REGISTER,
  CHAN_GENERIC_TASK,
  MESSAGE_LEVEL_MAP,
  TASK_STATUS_MAP,
  VALID_MESSAGE_TYPES,
};
